import Backbone from '@polleverywhere/backbone';
import Chain from './ajax/chain.js';
import Environment from './models/environment.js';
var env = new Environment();
Backbone.ajax = new Chain().ajax;
export default env;